import { initializeApp } from "firebase/app";
import {getAuth,GoogleAuthProvider} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBQ7SjGGZ6fkW2lmIATf2Zx45JozynOjes",
    authDomain: "admin-side-ce210.firebaseapp.com",
    databaseURL: "https://admin-side-ce210.firebaseio.com",
    projectId: "admin-side-ce210",
    storageBucket: "admin-side-ce210.appspot.com",
    messagingSenderId: "720997050143"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const provider = new GoogleAuthProvider();
export {auth,provider};